import { computed, Injectable, NgZone, signal } from '@angular/core';

export interface UserProfile {
  id: string; // Google sub ID (maps to cloud backup google_sub)
  name: string;
  email: string;
  picture: string;
}

declare const google: any;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private userSignal = signal<UserProfile | null>(this.loadStoredUser());

  readonly currentUser = computed(() => this.userSignal());
  readonly isAuthenticated = computed(() => !!this.userSignal());

  // Replace with your Google Cloud Web Client ID
  private readonly clientId =
    '94301568877-ekt1mb4urpigitn0f4d5rivkm1vjjv29.apps.googleusercontent.com';

  constructor(private ngZone: NgZone) {}

  initGoogleSignIn(buttonContainerId: string): void {
    if (typeof google === 'undefined') {
      console.warn('Google Identity Services script not yet loaded.');
      return;
    }

    google.accounts.id.initialize({
      client_id: this.clientId,
      callback: (response: any) => this.handleCredential(response),
      auto_select: false,
    });

    const container = document.getElementById(buttonContainerId);
    if (container) {
      google.accounts.id.renderButton(container, {
        theme: 'outline',
        size: 'large',
        type: 'standard',
      });
    }
  }

  private handleCredential(response: any): void {
    const base64Url = response.credential.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );

    const payload = JSON.parse(jsonPayload);

    const profile: UserProfile = {
      id: payload.sub,
      name: payload.name,
      email: payload.email,
      picture: payload.picture,
    };

    this.ngZone.run(() => {
      localStorage.setItem('slt_user_profile', JSON.stringify(profile));
      this.userSignal.set(profile);
    });
  }

  signOut(): void {
    localStorage.removeItem('slt_user_profile');
    this.userSignal.set(null);
  }

  private loadStoredUser(): UserProfile | null {
    const raw = localStorage.getItem('slt_user_profile');
    return raw ? JSON.parse(raw) : null;
  }
}
